import { cva } from "class-variance-authority"

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // Flat fill + 1 px outline: the brand rule, and WCAG 1.4.11 — brand
        // blue on the light ground is ~1.3:1 at the edge, so the fill alone
        // cannot delimit the control. Text on blue is always charcoal
        // (`--primary-foreground`).
        default:
          "border border-foreground bg-primary text-primary-foreground hover:bg-primary/90 btn-spring motion-reduce:transition-none",
        destructive:
          "border border-foreground bg-destructive text-destructive-foreground hover:bg-destructive/90",
        success: "border border-foreground bg-success text-success-foreground hover:bg-success/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "border border-border bg-secondary text-secondary-foreground hover:bg-secondary/80 btn-spring motion-reduce:transition-none",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        icon: "rounded hover:bg-accent hover:text-accent-foreground",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        md: "h-8 rounded-md px-3 text-sm",
        lg: "h-10 rounded-md px-8",
        icon: "size-10",
        link: "w-fit p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)
